import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { auth } from "../../firebase";
import "./ErrorPage.css";
const ErrorPage = ({ page }) => {
  const [navigation, setNavigation] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (auth.currentUser) {
      setNavigation(page === "indexme" ? "/indexme" : "/backlinkvault");
    } else {
      setNavigation("/login");
    }
    const setTime = setTimeout(() => setLoading(false), 500);

    return () => clearTimeout(setTime);
  });

  return (
    <div className="error-container">
      <div className="error-text">
        <span className="text-color">Oops!</span>
        This is awkward... You are looking for something that doesn't actually
        exist.
      </div>
      <img src="../404Page.jpeg" alt="*" width={"100%"} height="100%" />

      <div>
        <Link className="button" to={navigation}>
          {loading
            ? "..."
            : navigation === "/login"
            ? "Go to Login page"
            : "Go to Dashboard page"}
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;
